module.exports = __webpack_public_path__ + "img/edit-organization-dialog.269aa9fc.png";